import { render, staticRenderFns } from "./ApeironProductList.vue?vue&type=template&id=11308b53"
import script from "./ApeironProductList.vue?vue&type=script&lang=js"
export * from "./ApeironProductList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports